export default __webpack_public_path__ + "static/Bandwidth-7546c58ce25c3de648706baabe588a91.svg";